export const NAMESPACE = 'global-snackbar';
